import React, { useState, useEffect } from 'react';
import saveImpstyles from "../../../css/SaveMappingPopup.module.css";
import { BackArrowButton } from "../../../fixedassetelements/button/Button";
import success from "../../../assets/icons/successsym.png";
import { ReactComponent as CloseIcon } from "../../../assets/icons/custModeLCloseIcon.svg";

const ImportMappingPopup = ({ onClose, onImport, savedMappings = [] }) => {
  const [selectedMapping, setSelectedMapping] = useState(null);

 const handleCardClick = (id) => {
    setSelectedMapping(id);
  };
  
  const handleImport = () => {
    if (!selectedMapping) return;
    
    const mapping = savedMappings.find(m => m.id === selectedMapping);
    if (mapping) {
      onImport(mapping);
      onClose();
    }
  };


  return (
    <div className={saveImpstyles.overlay} onClick={onClose}>
      <div
        className={`${saveImpstyles.modal} ${saveImpstyles.importModal}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={saveImpstyles.header}>
          <div className={saveImpstyles.headerLeft}>
            <button className={saveImpstyles.backButton}>
              <BackArrowButton onClick={onClose} />
            </button>
            <h2 className={saveImpstyles.title}>Import Mapping</h2>
          </div>
          <button className={saveImpstyles.closeButton} onClick={onClose}>
            <CloseIcon className={saveImpstyles.closeIconLarge} />
          </button>
        </div>

        <div className={saveImpstyles.subtitle}>
          <p>Select from your previously saved label to column header mappings to instantly map your current uploaded file</p>
        </div>

        <div className={saveImpstyles.content}>
          {savedMappings.length > 0 ? (
            <div className={saveImpstyles.grid}>
              {savedMappings.map((mapping) => (
                <div
                  key={mapping.id}
                  onClick={() => handleCardClick(mapping.id)}
                  className={`${saveImpstyles.card} ${
                    selectedMapping === mapping.id ? saveImpstyles.cardSelected : ''
                  }`}
                >
                  {selectedMapping === mapping.id && (
                    <div className={saveImpstyles.checkmark}>
                      <img src={success} alt="selected" />
                    </div>
                  )}

                  <div className={saveImpstyles.cardContent}>
                    <h3 className={saveImpstyles.mappingName}>{mapping.name}</h3>
                    <p className={saveImpstyles.companyName}>{mapping.companyName}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={saveImpstyles.emptyState}>
              <p>No saved mappings available. Save a mapping first to import it later.</p>
            </div>
          )}
        </div>

        <div className={saveImpstyles.footer}>
          <button className={saveImpstyles.cancelButton} onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            disabled={!selectedMapping}
            className={saveImpstyles.importButton}
            onClick={handleImport}
          >
            Import Mapping
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImportMappingPopup;